/**
 * Directive Dependencies
 */
import Clipboard from 'clipboard'

/**
 * Clipboard Copy Directive
 *
 * @type {Object}
 */
export default {
    inserted (el, binding, vnode) {
        /* eslint-disable no-new */
        var clipboard = new Clipboard(el)
        /* eslint-disable no-new */

        clipboard.on('success', (e) => {
            vnode.context.$bus.$emit('copied', e)
        })

        clipboard.on('error', (e) => {
            vnode.context.$bus.$emit('copyFailed', e)
        })
    }
}



// WEBPACK FOOTER //
// ./src/directives/clipboard.js